export default async function getPath($http, $route, path) {
  let id = $route.params.id;
  return await $http.get(path + id);
}



// WEBPACK FOOTER //
// ./src/utils/getPath.js